/*
    Subtitle component that will be used as a component for introducing new sections accross our app.

    Params:


*/

import React from "react";

import TextField from "./TextField";
import TitleField from "./TitleField";

import Reveal from "../motion/Reveal";

import '../../styles/text/ContentTitle.css';

const ContentTitle = ({title, subTitle, centered=true}) => {

    return (
        <>
            <Reveal className="home-products-overview-title-container">
                <div className="home-products-overview-title">
                    <TitleField title={title} bold={true} fontSize="2.25rem"/>
                </div>
                <div className="home-products-overview-subtitle">
                    <TextField text={subTitle}/>
                </div>
            </Reveal>
        </>

    )
};


export default ContentTitle;